export default "__VITE_ASSET__Btdtrc8s__"